import styled from 'styled-components'
import ButtonDownload from '../../ButtonDownload/ButtonDownload'
import pxToRem from '../../../utils/pxToRem'
import { deviceMax } from '../../../theme/breakpoints'
import { CarouselVariantEnum } from '../Carousel'

export const StyledButtonDownload = styled(ButtonDownload)`
  width: 100%;
  ${({ $orientation }) =>
    $orientation === CarouselVariantEnum.horizontal &&
    `
    a {
      max-width: calc(100% - ${pxToRem(50)});
    }
    `};

  @media ${deviceMax.tablet} {
    max-width: 100%;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: initial;
    }
  }
`
